/** Matches what the storage layer accepts without re-encoding. */
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024

/** Why a picked file cannot be uploaded as an image, or `null` when it can. */
export function imageFileError(file: File): string | null {
  if (!file.type.startsWith('image/')) return 'That file is not an image.'
  if (file.size > MAX_UPLOAD_BYTES) return 'Images have to be under 5 MB.'
  return null
}
